import type { Configuration, RedirectRequest } from '@azure/msal-browser';

// Mirrors obw-pmp/authConfig. Single app-registration model: the SPA client id
// is also the API audience, so the API scope is api://{clientId}/access_as_user.
// Values come from Vite env vars (VITE_*), never hardcoded.
export const msalConfig: Configuration = {
  auth: {
    clientId:              import.meta.env.VITE_AZURE_CLIENT_ID ?? '',
    authority:             `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID ?? 'common'}`,
    redirectUri:           window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation:          'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (_level, message, containsPii) => {
        if (containsPii) return;
        if (import.meta.env.DEV) console.log(`[MSAL] ${message}`);
      },
    },
  },
};

/** Scopes for interactive login / redirect. OIDC-only — these never require admin
 *  consent (the tenant disables user consent), so sign-in has no approval prompt.
 *  The API token (access_as_user) is acquired separately and is pre-authorized. */
export const loginRequest: RedirectRequest = {
  scopes: ['openid', 'profile', 'email'],
};

/** Scopes for calling the backend API (account must be set before use). */
export const apiScopes = [`api://${import.meta.env.VITE_AZURE_CLIENT_ID}/access_as_user`];
